module.exports = __webpack_public_path__ + "img/product-express.two.3a16f95.png";